import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React, {useEffect, useState} from "react";
import {useIframeMessenger} from "../../../Hooks/UseIframeMessenger"
import useLocation from "../../../Hooks/CurrentUrlHook";
import ConditionalComponent from "../../Shared/ConditionalComponent";
import Settings from "../../../settings.json"

export const TestAiChatModal = observer(({}) => {
    const {aiStore, aiStudioStore} = useStores();
    const location = useLocation()
    const [isStarted, setIsStarted] = useState(false)

    const { iframeRef, sendMessage } = useIframeMessenger({
        onMessage: (data) => {
            console.log('Got message from iframe:', data);
        },
        isTestMode: true,
    });

    const CloseModal = () => {
        aiStore.isTestChatOpen = false
    }
    useEffect(async() => {
        aiStore.sendMessageToTestIframe = sendMessage
    }, [sendMessage]);

    useEffect(async() => {
        if (aiStore.isTestChatOpen && !isStarted) {
            await aiStore.sendInitialValues(window.location.href, aiStore.sendMessageToTestIframe, true, aiStudioStore.workspace)
        }
    }, [aiStore.isTestChatOpen]);


    return (
        <>
            <ConditionalComponent if={aiStore.isTestChatOpen}>
                <div
                    className="fixed inset-0 bg-background-overlay"
                    style={{zIndex: 1999, opacity:'0.5'}}
                    onClick={CloseModal}
                />
            </ConditionalComponent>

            <div className="fixed left-1/2 -translate-x-1/2 overflow-hidden" style={{
                top: '10%',
                zIndex: 2000,
                width: aiStore.size('520px'),
                height: aiStore.size('768px'),
                maxHeight: '90vh',
                display: aiStore.isTestChatOpen ? 'block' : 'none'
            }}>
                <iframe
                    ref={iframeRef}
                    src={Settings.iframeUrl}
                    title="Child App"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                />
            </div>
        </>
    );

});